/* KleenKick V3 — Header: transparent → solid on scroll + Wiggle CTA on section entry */
(function () {
  'use strict';
  const header = document.getElementById('kk-header');
  if (!header) return;

  const threshold = 80;

  function onScroll() {
    const y = window.pageYOffset;
    if (y > threshold) header.classList.add('is-solid');
    else header.classList.remove('is-solid');
    // Header rămâne MEREU vizibil — wiggle CTA depinde de asta.
    // (Dezactivat hide-on-scroll: ar fi ascuns header-ul exact când treci între secțiuni.)
    header.classList.remove('is-hidden');
  }

  let ticking = false;
  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => { onScroll(); ticking = false; });
      ticking = true;
    }
  }, { passive: true });

  onScroll();

  /* ----------------------------------------------------------------
     Meniu mobil — toggle hamburger (open/close, scroll lock, Escape)
     ---------------------------------------------------------------- */
  const burger = document.getElementById('kk-burger');
  const mobileMenu = document.getElementById('kk-mobile-menu');

  // Header-ul are un transform (GSAP) → orice position:fixed în interior se raportează
  // la header, nu la viewport. Mutăm meniul în <body> ca să fie cu adevărat full-screen.
  if (mobileMenu && mobileMenu.parentElement !== document.body) {
    document.body.appendChild(mobileMenu);
  }

  if (burger && mobileMenu) {
    const closeMenu = function () {
      header.classList.remove('is-menu-open');
      burger.setAttribute('aria-expanded', 'false');
      mobileMenu.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('kk-menu-open');
    };
    const openMenu = function () {
      header.classList.add('is-menu-open');
      burger.setAttribute('aria-expanded', 'true');
      mobileMenu.setAttribute('aria-hidden', 'false');
      document.body.classList.add('kk-menu-open');
    };
    burger.addEventListener('click', function () {
      if (header.classList.contains('is-menu-open')) closeMenu();
      else openMenu();
    });
    const closeBtn = document.getElementById('kk-menu-close');
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    mobileMenu.querySelectorAll('[data-kk-menu-link]').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && header.classList.contains('is-menu-open')) closeMenu();
    });
  }

  /* ----------------------------------------------------------------
     Wiggle CTA — trigger when a NEW section crosses viewport center
     - cooldown 1500ms anti-spam
     - skip first paint (sections already in view shouldn't fire)
     - respects prefers-reduced-motion
     ---------------------------------------------------------------- */
  const wiggleTarget = document.querySelector('[data-kk-wiggle-target]');
  if (!wiggleTarget) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  const sections = document.querySelectorAll('main section[id], main .kk-section, main .kk-hero');
  if (!sections.length) return;

  const COOLDOWN = 1500;
  let lastWiggle = 0;
  let armed = false;

  function wiggle() {
    const now = Date.now();
    if (now - lastWiggle < COOLDOWN) return;
    lastWiggle = now;
    wiggleTarget.classList.remove('is-wiggling');
    void wiggleTarget.offsetWidth; // force reflow so animation restarts
    wiggleTarget.classList.add('is-wiggling');
    setTimeout(() => wiggleTarget.classList.remove('is-wiggling'), 550);
  }

  // Arm only after user actually scrolls past hero — avoids load-time wiggle
  function armOnFirstScroll() {
    if (window.pageYOffset > 200) {
      armed = true;
      window.removeEventListener('scroll', armOnFirstScroll);
    }
  }
  window.addEventListener('scroll', armOnFirstScroll, { passive: true });

  const observer = new IntersectionObserver((entries) => {
    if (!armed) return;
    entries.forEach((entry) => {
      if (entry.isIntersecting) wiggle();
    });
  }, {
    rootMargin: '-45% 0px -45% 0px',
    threshold: 0
  });

  sections.forEach((s) => observer.observe(s));
})();
